import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import MuiRadio from '@mui/material/Radio';
import { useRadioGroup } from '@mui/material/RadioGroup';
import Label from '../Label/Label.js';
import { ReactComponent as ForwardRef } from '../../assets/icons/RadioSmall.svg.js';
import { ReactComponent as ForwardRef$1 } from '../../assets/icons/CheckedRadioSmall.svg.js';

const Radio = (_a) => {
    var { hint, hintDuration, children, className, disabled, 'data-testid': testId } = _a, rest = __rest(_a, ["hint", "hintDuration", "children", "className", "disabled", 'data-testid']);
    const radioGroup = useRadioGroup();
    return (jsx(Label, Object.assign({ hint: hint, hintDuration: hintDuration, className: className, disabled: disabled, control: jsx(MuiRadio, Object.assign({ icon: jsx(ForwardRef, {}), checkedIcon: jsx(ForwardRef$1, {}), disabled: disabled, checked: (radioGroup === null || radioGroup === void 0 ? void 0 : radioGroup.value) && rest.checked, "data-testid": testId }, rest)) }, { children: children })));
};

export { Radio as default };
//# sourceMappingURL=Radio.js.map
